import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'
import { debounce } from "lodash"

const COUNT_FIELD_PREFIXES = [
  'business[advisory_position]',
  'business[transaction_value_min]',
  'business[transaction_value_max]',
  'business[industry_small_sector_ids]',
  'business[prefecture_ids]',
  'business[shared_outside_group]',
]

export default class extends Controller {
  static values = { url: String, businessId: String }

  declare readonly urlValue: string
  declare readonly businessIdValue: string

  onChange(event: Event): void {
    const target = event.target as HTMLInputElement
    if (this.isCountField(target.name)) this.debouncedRefresh()
  }

  // NOTE: 業界モーダルの確定・都道府県の一括選択は change イベントを発火しないため、専用イベントで拾う
  onSelectionChanged(): void {
    this.debouncedRefresh()
  }

  private onVisibilityChange = (): void => {
    if (document.visibilityState !== 'visible') return

    document.removeEventListener('visibilitychange', this.onVisibilityChange)
    this.refreshCount()
  }

  private debouncedRefresh = debounce((): void => this.refreshCount(), 300)

  connect(): void {
    if (document.visibilityState === 'visible') {
      this.refreshCount()
    } else {
      document.addEventListener('visibilitychange', this.onVisibilityChange)
    }
  }

  disconnect(): void {
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
    this.debouncedRefresh.cancel()
  }

  refreshCount(): void {
    get(this.urlValue, { responseKind: 'turbo-stream', query: this.buildQuery() })
  }

  private buildQuery(): URLSearchParams {
    const query = new URLSearchParams()
    new FormData(this.element as HTMLFormElement).forEach((value, name) => {
      if (typeof value === 'string' && this.isCountField(name)) query.append(name, value)
    })
    if (this.businessIdValue) query.append('business_id', this.businessIdValue)
    return query
  }

  private isCountField(name: string): boolean {
    return COUNT_FIELD_PREFIXES.some((prefix) => name.startsWith(prefix))
  }
}
